import Model from './model.js';
import FileInfo from './fileInfo.js';
export default class DeathCertificate extends Model
{
    constructor(id, personId, certificateNumber, dateOfIssue, file = null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.certificateNumber  = certificateNumber;
        this.dateOfIssue        = dateOfIssue;
        this.file               = file ?? new FileInfo();

        this.init()
    }

    setBinaryFile(binaryFile){
        if (!this.file || typeof this.file !== 'object') this.file = new FileInfo();
        this.file.binaryFile = binaryFile ?? null;
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        let formData = new FormData();
        formData.append('certificateNumber', this.certificateNumber ?? "")
        formData.append('dateOfIssue', this.dateOfIssue ?? "")
        if(this.file?.binaryFile) formData.append('file', this.file.binaryFile);
        
        return formData;
    }

    mapToCreate(){
        let formData = this.mapToUpdate();
        formData.append('personId', this.personId ?? null);
        
        return formData;
    }
}

